import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import AOSInit from "../../components/Animation/AOSInit";
import NavBarHome from "../../components/NavBar/NavBarHome";

const suggestions = {
  "Ateliers & Projets": [
    { label: "Construire ton premier robot avec Micro:bit", link: "/courses-list" },
    { label: "Atelier design 3D : modélise et imprime tes créations", link: "/courses-list" },
  ],
  "Tuteurs & Mentors": [
    { label: "Devenir tuteur GoNextMaker", link: "/become-an-instructor" },
    { label: "Nos mentors en électronique et robotique", link: "/instructors-list" },
  ],
  "Blog": [
    { label: "Pourquoi l'apprentissage par la pratique change la donne en Afrique", link: "/blog" },
    { label: "Retour sur le Summer Camp 2025", link: "/blog" },
  ],
  "FAQ & Aide": [
    { label: "Comment m'inscrire à un atelier ?", link: "/faqs" },
    { label: "Que faire si j'ai oublié mon mot de passe ?", link: "/faqs" },
  ],
};

// Hook utilitaire pour récupérer les query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchPage = () => {
  const query = useQuery().get("query") || "";
  const navigate = useNavigate();

  const results = useMemo(() => {
    if (!query) return {};
    return Object.entries(suggestions).reduce((acc, [category, items]) => {
      const filtered = items.filter((item) =>
        item.label.toLowerCase().includes(query.toLowerCase())
      );
      if (filtered.length > 0) acc[category] = filtered;
      return acc;
    }, {});
  }, [query]);

  const handleGoBack = () => {
    navigate(-1); // Retour à la page précédente
  };

  return (
    <div className="min-h-screen bg-light-5 py-16 px-6 pt-[92px]">
      <AOSInit />
      <NavBarHome />
      <div className="max-w-5xl pt-6 mx-auto">
        {/* Bouton Retour */}
        <button
          onClick={handleGoBack}
          className="flex items-center gap-2 text-blue-1 hover:text-purple-1 mb-6 transition-colors duration-200"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          <span className="font-medium">Retour</span>
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <MagnifyingGlassIcon className="h-6 w-6 text-blue-1" />
          <h1 className="text-2xl font-bold text-dark-1">
            Résultats pour « {query} »
          </h1>
        </div>

        {/* Résultats */}
        {Object.keys(results).length > 0 ? (
          <div className="space-y-8">
            {Object.entries(results).map(([category, items]) => (
              <div key={category}>
                <h2 className="text-lg font-semibold text-dark-1 mb-3">{category}</h2>
                <ul className="space-y-2">
                  {items.map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.link}
                        className="block p-3 bg-white rounded-lg shadow hover:shadow-md transition text-dark-1 hover:text-purple-1"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-light-1 italic">
            Aucun résultat trouvé pour « {query} »
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchPage;